import { w } from "@/api/words";

import type { SurfaceMeta } from "../registry";

// Объявление поверхности S-52 «Мій дашборд». Тека с этим файлом — и есть
// регистрация.
//
// ⚠ Это **второй корень навигации** (`G71`): после входа — сюда у всех и всегда
// (`G93`), кроме возврата на прерванный адрес (решение оркестратора 71 (б)).
// Отметкой пресета не выдаётся и строкой матрицы `ENT-25` не является: он есть
// у каждого, у кого есть вход. Пункт меню «Дашборд» стоит над группами (`G89`),
// его отдаёт меню сервера, а не этот файл.
export const meta: SurfaceMeta = {
  code: "S-52",
  // Название — слово словаря по коду (`G117`), читается при показе.
  get title_uk() {
    return w("s52_title");
  },
  path: "/s-52",
};
